export const HIDDEN_FRESHCHAT_ROOT_IDS = [452674, 454982]

export const HIDDEN_FRESHCHAT_PATH_NAMES = '/biblioteca/avaliacao-leitora'
